/**
 * Bilingual UI strings for the App Library Search app.
 */
import type { Lang } from './constants';

const translations = {
  en: {
    by: 'by',
    searchLabel: 'Search apps',
    searchPlaceholder: 'Search by keyword',
    searchButton: 'Search',
    filterBy: 'Filter by:',
    filterButton: 'View all filters',
    clear: 'Clear',
    clearButton: 'Clear filters',
    loadMore: 'Load more',
    loading: 'Loading results...',
    noResults: 'No results found.',
    noAppsAvailable: 'No apps are currently available. Please check back later.',
    resultsCount: (count: number, total: number) =>
      `Showing ${count} of ${total} apps`,
    piiError: 'Please do not enter personal information.',
    close: 'Close',
    apply: 'Apply',
    applyFilters: 'Apply filters',
    clearAllFilters: 'Clear all filters',
    getDetails: 'Get details',
    facetLabels: {
      app_price_type: 'Price',
      app_platforms: 'Platform',
      app_condition: 'Health condition',
      app_key_features: 'Key feature',
    }
  },
  es: {
    by: 'por',
    searchLabel: 'Buscar aplicaciones',
    searchPlaceholder: 'Buscar por palabra clave',
    searchButton: 'Buscar',
    filterBy: 'Filtrar por:',
    filterButton: 'Mostrar todos los filtros',
    clear: 'Borrar',
    clearButton: 'Borrar filtros',
    loadMore: 'Cargar más',
    loading: 'Cargando resultados...',
    noResults: 'No se encontraron resultados.',
    noAppsAvailable: 'No hay aplicaciones disponibles actualmente. Vuelva a consultar más tarde.',
    resultsCount: (count: number, total: number) =>
      `Mostrando ${count} de ${total} aplicaciones`,
    piiError: 'No ingrese información personal.',
    close: 'Cerrar',
    apply: 'Aplicar',
    applyFilters: 'Aplicar filtros',
    clearAllFilters: 'Borrar todos los filtros',
    getDetails: 'Ver detalles',
    facetLabels: {
      app_price_type: 'Precio',
      app_platforms: 'Plataforma',
      app_condition: 'Condición de salud',
      app_key_features: 'Característica clave',
    }
  },
} as const;

export type Translations = typeof translations[keyof typeof translations];

export function t(lang: Lang): Translations {
  return translations[lang];
}
